export default __webpack_public_path__ + "7ef4cd57c9803de6e292321dc5c0bed0.svg";